// Types
type RuntimeConfig = {
  PUBLIC_API_HOST: string;
  PUBLIC_API_PATH: string;
  PUBLIC_API_WEBSOCKET: string;
  SENTRY_DSN: string;
  ENVIRONMENT: string;
  PRODUCTION_APP_URL: string;
  ENABLE_BASE_FOOD_LABEL_SCAN: boolean;
  ENABLE_BODY_FAT: boolean;
};
type AppConfig = {
  publicRuntimeConfig: RuntimeConfig;
};

// Configuration
const {
  VITE_PUBLIC_API_HOST: PUBLIC_API_HOST,
  VITE_PUBLIC_API_PATH: PUBLIC_API_PATH,
  VITE_PUBLIC_API_WEBSOCKET: PUBLIC_API_WEBSOCKET,
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_SENTRY_DSN: SENTRY_DSN,
  VITE_PRODUCTION_APP_URL: PRODUCTION_APP_URL,
  VITE_PUBLIC_ENABLE_BASE_FOOD_LABEL_SCAN,
  VITE_PUBLIC_ENABLE_BODY_FAT,
} = import.meta.env;

const runtimeConfig: RuntimeConfig = {
  PUBLIC_API_HOST: PUBLIC_API_HOST ?? "",
  PUBLIC_API_PATH: PUBLIC_API_PATH ?? "",
  PUBLIC_API_WEBSOCKET: PUBLIC_API_WEBSOCKET ?? "",
  SENTRY_DSN: SENTRY_DSN ?? "",
  ENVIRONMENT: ENVIRONMENT ?? "",
  PRODUCTION_APP_URL: PRODUCTION_APP_URL ?? "https://app.nutriflex.fit",
  ENABLE_BASE_FOOD_LABEL_SCAN:
    VITE_PUBLIC_ENABLE_BASE_FOOD_LABEL_SCAN === "true",
  ENABLE_BODY_FAT: VITE_PUBLIC_ENABLE_BODY_FAT === "true",
};

const appConfig: AppConfig = {
  publicRuntimeConfig: runtimeConfig,
};

interface IApplicationConfiguration {
  get(): AppConfig;
  getPublicRuntimeConfig(): RuntimeConfig;
  getCurrentEnvironment(): string;
  isDevelopment(): boolean;
  getApiURL(): string;
  getProductionAppURL(): string;
  isBaseFoodLabelScanEnabled(): boolean;
  isBodyFatEnabled(): boolean;
}

export const APP_CONFIG: IApplicationConfiguration = {
  get() {
    return appConfig;
  },
  getPublicRuntimeConfig() {
    return appConfig.publicRuntimeConfig;
  },
  getCurrentEnvironment() {
    return appConfig.publicRuntimeConfig.ENVIRONMENT;
  },
  isDevelopment() {
    return appConfig.publicRuntimeConfig.ENVIRONMENT === "development";
  },
  getApiURL() {
    return (
      appConfig.publicRuntimeConfig.PUBLIC_API_HOST +
      appConfig.publicRuntimeConfig.PUBLIC_API_PATH
    );
  },
  getProductionAppURL() {
    return appConfig.publicRuntimeConfig.PRODUCTION_APP_URL;
  },
  isBaseFoodLabelScanEnabled() {
    return appConfig.publicRuntimeConfig.ENABLE_BASE_FOOD_LABEL_SCAN;
  },
  isBodyFatEnabled() {
    return appConfig.publicRuntimeConfig.ENABLE_BODY_FAT;
  },
};
